<script>
import { Routes } from '../../../../Constants/Routes.ts'
import { globalVariablesMixin } from '../../Mixins/global'
import mixinComponent from '../../Mixins/mixinComponent'
import Badge from '../UI/Badge.vue'
import ButtonLink from '../UI/Button/ButtonLink.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import LazyContent from '../UI/Loading/LazyContent.vue'
import PlaceholderContent from '../UI/Loading/PlaceholderContent.vue'
import RepurchasedContractList from './RepurchasedContractList.vue'

export default {
  components: {
    ButtonLink,
    PlaceholderContent,
    RepurchasedContractList,
    Badge,
    BlockContent,
    LazyContent,
  },
  // TODO Include logic of restructuration.js into new restructuration module
  //      Rename this component to without "simulation" (and other restructuring components)
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    restructuring: {
      type: [Object, null],
      required: true,
      default: null,
    },
    contractId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data: () => ({
    elements: [],
    contracts: [],
  }),
  computed: {
    restructuringUrl() {
      return {
        name: Routes.RESTRUCTURING_VIEW,
        params: {
          id: this.restructuring.id,
        },
      }
    },
    restructuredContractUrl() {
      const restructuredContractId = this.restructuring.restructuredContract?.id
      if (!restructuredContractId) {
        return null
      }

      if (restructuredContractId === this.contractId) {
        return null
      }

      return {
        name: Routes.CONTRACT_VIEW,
        params: {
          id: restructuredContractId,
        },
      }
    },
  },
  methods: {
    getActionLabel({ actionType }) {
      return this.$t(`contract.restructuring.types.${actionType}.label`)
    },
  },
}
</script>
<template>
  <LazyContent :loading="!restructuring">
    <BlockContent>
      <template #header-title>
        <div class="d-flex align-items-center mb-3">
          <div class="d-flex align-items-center flex-grow-1">
            <h4 class="mb-0">{{ restructuring.label }}</h4>
            <div v-if="restructuring.actions.length > 0" class="d-flex ml-2">
              <Badge v-for="action in restructuring.actions" :key="action.actionType" class="mr-2" type="secondary">
                {{ getActionLabel(action) }}
              </Badge>
            </div>
          </div>
          <ButtonLink
            v-if="restructuredContractUrl"
            type="show"
            label="restructuring.actions.viewRestructuredContract"
            :href="restructuredContractUrl"
            external
          />
          <ButtonLink type="show" label="restructuring.actions.view" :href="restructuringUrl" external />
        </div>
      </template>

      <template v-if="restructuring.outstandingRepurchase">
        <RepurchasedContractList :action="restructuring.outstandingRepurchase" readonly />
      </template>
    </BlockContent>

    <template #loader>
      <BlockContent>
        <PlaceholderContent :rows="6" />
      </BlockContent>
    </template>
  </LazyContent>
</template>
